<template>
  <v-app>
      <dashboard-core-app-bar />

      <dashboard-core-drawer />

      <dashboard-core-view v-if="!isLoading" />

      <Loading 
        :active.sync="isLoading" 
        :is-full-page="true"
        color="#2EC4B6"
        background-color="#EEEEEE"
      >
      </Loading>
  </v-app>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SearchService from '@/services/SearchService'

export default {
  name: "DashboardIndex",

  components: {
    Loading,
    DashboardCoreAppBar: () => import("./components/core/AppBar"),
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    DashboardCoreView: () => import("./components/core/View"),
  },

  data: () => ({
    expandOnHover: false,
    isLoading: false,
  }),

  async created() {
    this.isLoading = true;
    await this.$ingredientService.fetchCosing();
    await this.$ingredientService.fetchCosingProhibited();
    await this.$ingredientService.fetchCosingRestricted();

    this.isLoading = false;

    if (this.user.id) {
      await this.initProjects();
      const searchService = new SearchService()
      searchService.getSearchKey()
    }
    
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
  },

  methods: {
    async initProjects() {
      await this.$store.dispatch("company/fetchCompany", this.user.id);
      await this.$store.dispatch("projects/fetchProjects", this.user.id);
    },
  },
};
</script>
